import { TableCell, TableRow } from "@mui/material";
import dele from "../../../../assets/DigitalMarketing/image/delete.svg";
import edit from "../../../../assets/DigitalMarketing/image/edit.svg";
import eye from "../../../../assets/DigitalMarketing/image/visibility.svg";
import { useEffect, useState } from "react";
import IosSwitchBtn from "../../../../Component/DigitalMarketing/IosSwitchbtn";
import useDeleteBox from "../../../../hooks/digitalMarketing/useDeleteBox";
import AlertDialog from "../../../../Component/DigitalMarketing/deleteConfirmation";
import {
  useDeleteLocationsMasterMutation,
  useUpdateLocationsStatusMutation,
} from "../../../../Service/Masters";
import { formatDate } from "./Utils/TableHeadList";
import { Branch_BUCKET_URL } from "../../../../Service/api/ApiUrls";

const TableList = (props) => {
  const { locationData, setShow, setUpdateData, refetch } = props;
  const [deleteLocations] = useDeleteLocationsMasterMutation();
  const [updateLocationsStatus] = useUpdateLocationsStatusMutation();
  const { open, message, openDelete, deleteId } = useDeleteBox();
  const [checkedStates, setCheckedStates] = useState([]);

  const handleChange = (index: any, id: any) => (event) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = event?.target?.checked;
    setCheckedStates(newCheckedStates);

    updateStatus(id, event.target.checked);
  };

  const updateStatus = async (id, status) => {
    await updateLocationsStatus({ id, activeStatus: status ? "1" : "0" });
    refetch();
  };

  const handleUpdate = (data) => {
    console.log(data)
    // setView(false);
    setShow(true);
    setUpdateData(data);
  };

  const deleteBranches = async (bool) => {
    if (bool) {
      await deleteLocations(deleteId);
      refetch();
    }
    openDelete("Are you sure you want to delete this Branch?", false, null);
  };

  useEffect(() => {
    if (locationData?.data) {
      setCheckedStates(locationData.data.map((a) => a?.activeStatus === 1));
    }
  }, [locationData]);

  return (
    <>
      <AlertDialog
        open={open}
        message={message}
        deleteBranches={deleteBranches}
      />
      {locationData?.data?.length > 0 ? (
        locationData.data.map((a, index) => (
          <TableRow key={a.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">
              <span className="d-flex gap-1 align-items-center">
                {a.imageName && a.imagePath ? (
                  <img
                    src={`${Branch_BUCKET_URL}/${a.imagePath}${a.imageName}`}
                    alt={a.branchName}
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      objectFit: "fill",
                    }}
                  />
                ) : (
                  <span
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      objectFit: "fill",
                      backgroundColor: "#CCCCCC",
                    }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <span
                      className="material-symbols-outlined fw-500"
                      style={{ color: "#F9F9FA" }}
                    >
                      location_city
                    </span>
                  </span>
                )}
                <span className="text-nowrap">{a.branchName}</span>
              </span>
            </TableCell>
            <TableCell align="left">{a.city}</TableCell>
            <TableCell align="left">
              <IosSwitchBtn
                onChange={handleChange(index, a.id)}
                checked={
                  checkedStates[index] !== undefined
                    ? checkedStates[index]
                    : false
                }
                label={checkedStates[index] ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align="left" className="text-nowrap">
              {formatDate(a.createdAt)}
            </TableCell>
            <TableCell align="left">{a.phone}</TableCell>
            <TableCell align="left">
              <img
                src={edit}
                alt="edit"
                className="blue-c action-icon cursor"
                onClick={() => handleUpdate(a)}
              />
              <img
                src={dele}
                alt="delete"
                className="delete-icon cursor action-icon ms-2"
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this Branch?",
                    true,
                    a.id
                  )
                }
              />
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={7} align="center">
            No data available.
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default TableList;
